var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-lg-12" }, [
      _c("div", { staticClass: "panel panel-bordered mb-0" }, [
        _vm._m(0),
        _c("div", { staticClass: "panel-body" }, [
          _c("form", { staticClass: "form-horizontal" }, [
            _c(
              "div",
              {
                staticClass: "form-group row",
                class: { ".is-invalid": _vm.$v.campaign.name.$error },
              },
              [
                _vm._m(1),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.campaign.name,
                          expression: "campaign.name",
                        },
                      ],
                      ref: "name",
                      staticClass: "form-control form__input",
                      attrs: {
                        type: "text",
                        autocomplete: "off",
                        placeholder: "Any name",
                      },
                      domProps: { value: _vm.campaign.name },
                      on: {
                        input: [
                          function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(_vm.campaign, "name", $event.target.value)
                          },
                          function ($event) {
                            return _vm.showValid("name")
                          },
                        ],
                      },
                    }),
                    _vm.showErrorNameValidation
                      ? _c("nameValidation", { attrs: { $v: _vm.$v } })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
            _c("div", { staticClass: "form-group row" }, [
              _c("h5", { staticClass: "col-md-12" }, [_vm._v("Quota Type")]),
              _c("div", { staticClass: "col-md-12 pl-50" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("div", { staticClass: "row", attrs: { "my-15px": "" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.campaign.type,
                          expression: "campaign.type",
                        },
                      ],
                      staticClass: "mr-10",
                      attrs: {
                        type: "radio",
                        value: "points",
                        id: "campaign_type_get_coin",
                      },
                      domProps: {
                        checked: _vm._q(_vm.campaign.type, "points"),
                      },
                      on: {
                        change: function ($event) {
                          return _vm.$set(_vm.campaign, "type", "points")
                        },
                      },
                    }),
                    _vm._m(2),
                  ]),
                  _c("div", { staticClass: "row", attrs: { "my-15px": "" } }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.campaign.type,
                          expression: "campaign.type",
                        },
                      ],
                      staticClass: "mr-10",
                      attrs: {
                        type: "radio",
                        value: "coins",
                        id: "campaign_type_discount",
                      },
                      domProps: { checked: _vm._q(_vm.campaign.type, "coins") },
                      on: {
                        change: function ($event) {
                          return _vm.$set(_vm.campaign, "type", "coins")
                        },
                      },
                    }),
                    _vm._m(3),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "panel-footer" }, [
          _c("div", { staticClass: "d-flex justify-content-between" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-round btn-default mx-10",
                attrs: { type: "button" },
                on: { click: _vm.close },
              },
              [
                _c("i", {
                  staticClass: "icon md-close",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(" Cancel "),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-round btn-primary",
                attrs: { type: "button" },
                on: { click: _vm.addCampaign },
              },
              [
                _c("i", {
                  staticClass: "icon md-check",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(" Create "),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-heading" }, [
      _c("h3", { staticClass: "panel-title" }, [_vm._v("Create New Quota")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "col-md-0 form-control-label form__label" },
      [_c("h5", [_vm._v("Quota Summary")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "campaign_type_get_coin" } }, [
      _c("p", { staticClass: "caption" }, [_vm._v("Get Coin")]),
      _c("p", { staticClass: "description" }, [
        _vm._v(" Limit the exchange from VIP points to coins "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("label", { attrs: { for: "campaign_type_discount" } }, [
      _c("p", { staticClass: "caption" }, [_vm._v("Discount")]),
      _c("p", { staticClass: "description" }, [
        _vm._v(" Limit the user of discount in exchange for coins "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }